export const facilitate = `
   <div
      class="w-full lg:w-[80%] mx-auto bg-white"
    >
          <h2 class="lg:text-4xl font-medium text-[#000072] text-xl text-center mt-24"
       data-aos="fade-up"
      data-aos-duration="500"
       >
          What We Facilitate
        </h2>
      <p class="py-2 text-center text-gray-600 mb-6"
      data-aos="fade-up"
      data-aos-duration="500"
      >
        We are a full-stack institutional debt raising platform <br/> that offers
        solutions to all stakeholders
      </p>

        <div class="mx-auto bg-white  flex flex-col gap-5 ">
      <div
        class="flex flex-col lg:flex-row p-5 gap-7 shadow-xl border border-gray-300 rounded-lg"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        <div  class="mx-auto">
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/debt.png"
            alt="Ibankey"
            class="rounded-2xl w-full"
          />
        </div>
        <div class="w-full lg:w-1/2">
          <p class="text-3xl font-bold text-[#4A2F7E] text-center mb-5">Debt</p>

          <p class="text-gray-600 font-[500]">
            Debt is a powerful tool for accelerating business growth. Our
            streamlined, one-time onboarding connects you with the right lenders
            from a wide network, ensuring access to the most competitive terms.
            The entire process is digital, fast, secure, and
            hassle-free—eliminating the usual friction of institutional debt
            raising. We handle the complexities so you can focus on scaling your
            business with confidence. Whether you’re expanding operations or
            strengthening working capital, our platform delivers the financing
            solutions you need, when you need them.
          </p>
        </div>
      </div>

      <div
        class="flex flex-col lg:flex-row p-5 gap-7 shadow-lg border border-gray-300 rounded-lg"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        <div class="mx-auto">
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/lender.png"
            alt="Ibankey"
            class="rounded-2xl w-full"
          />
        </div>
        <div class="w-full lg:w-1/2">
          <p class="text-3xl font-bold text-[#4A2F7E] text-center mb-5">
            Supply Chain Finance
          </p>

          <p class="text-gray-600 font-[500]">
            We offer a variety of liquidity programs designed to efficiently manage both payables and receivables financing. Our solutions are tailored to help businesses maintain healthy cash flow and ensure timely payments. With access to a wide network of trusted lending partners, businesses can choose from a broad range of options that best suit their financial needs. Whether it's short-term working capital or long-term funding, our platform provides the flexibility and support required to keep your operations running smoothly.
          </p>
        </div>
      </div>
    </div>
    </div>

  `;
